import type { WizardData, WizardState, WizardStep } from './wizard-state';


type CommitAction = {
    [K in keyof WizardData]: { type: 'commit'; key: K; value: WizardData[K] }
}[keyof WizardData];


export type WizardAction =
    | CommitAction
    | { type: 'goto'; step: WizardStep }
    | { type: 'next' }
    | { type: 'back' }
    | { type: 'reset' };


const STEP_ORDER: WizardStep[] = [ 'email', 'profile', 'plan', 'payment', 'confirmation' ];


const shift = (step: WizardStep, delta: 1 | -1): WizardStep => {
    const index = STEP_ORDER.indexOf(step);
    const next  = Math.max(0, Math.min(STEP_ORDER.length - 1, index + delta));
    return STEP_ORDER[next];
};


export const wizardReducer = (state: WizardState, action: WizardAction): WizardState => {
    if (!action) return state;

    switch (action.type) {
        case 'commit':
            return {
                ...state,
                data: { ...state.data, [action.key]: action.value },
            };

        case 'goto':
            return { ...state, step: action.step };

        case 'next':
            return { ...state, step: shift(state.step, 1) };

        case 'back':
            return { ...state, step: shift(state.step, -1) };

        case 'reset':
            return { step: 'email', data: {} };

        default:
            return state;
    }
};
